export default __webpack_public_path__ + "0118025f30365a29ef98563c82c5c209.png";